
export class MemoryCache {

    constructor(){
        if (window.__cache == null) {
            this._items = {};
        }
        else{
            console.warn("[w428273-ADM] Cache object should be accessed using Cache.instance. Avoid using the constructor");
            this._items = window.__cache._items;
        }
    }

    set(name, value) {
        this._items[name] = value;
    }

    get(name, value) {
        return this._items[name];
    }

    contains(name){
        let obj = this._items[name];
        return (obj != null);
    }

    removeItem(name, value){
        delete this._items[name];
    }

    static get instance(){

        if (window.__cache == null){
            window.__cache = new MemoryCache();
        }

        return window.__cache;
    }

}



